/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activityGet} from '../api'

export const useMutationActivityGet = createReactQueryMutationHook('activityGet', activityGet)
